import React from 'react';

export const IdeaSVG = props => {
	const { id } = props;

	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 64 64'>
			<defs>
				<linearGradient
					id='swipe-gradient-idea'
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(35)'
				>
					<stop offset='0' stop-color='#3192f4'>
						<animate
							id={`trans4-${id}`}
							dur='1s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color='#7b868c'>
						<animate
							id={`trans4-${id}`}
							dur='1s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
				<linearGradient
					id='linear-gradient'
					x1='.875'
					x2='.004'
					y1='.788'
					y2='.107'
					gradientUnits='objectBoundingBox'
				>
					<stop offset='0' stop-color='#c1c5c8' />
					<stop offset='1' />
				</linearGradient>
				<linearGradient
					id='linear-gradient-2'
					x1='1.489'
					x2='-.566'
					y1='1.272'
					y2='-.444'
					gradientUnits='objectBoundingBox'
				>
					<stop offset='0' stop-color='#fff' />
					<stop offset='.518' stop-color='#edefef' />
					<stop offset='1' stop-color='#7b868c' />
				</linearGradient>
				<linearGradient
					id='linear-gradient-3'
					x1='.901'
					x2='-.881'
					y1='1'
					y2='-1.453'
					gradientUnits='objectBoundingBox'
				>
					<stop offset='0' stop-color='#dfe1e1' />
					<stop offset='1' stop-color='#a2a9ad' />
				</linearGradient>
				<linearGradient
					id='linear-gradient-4'
					x1='2.149'
					x2='.676'
					y1='-3.325'
					y2='-4.029'
					gradientUnits='objectBoundingBox'
				>
					<stop offset='0' stop-color='#edefef' />
					<stop offset='1' stop-color='#7b868c' />
				</linearGradient>
				<filter
					id='socket'
					width='19.99'
					height='15.434'
					x='22.95'
					y='40.434'
					filterUnits='userSpaceOnUse'
				>
					<feOffset dx='.75' dy='.05' />
					<feGaussianBlur result='blur' stdDeviation='.5' />
					<feFlood flood-opacity='.251' />
					<feComposite in2='blur' operator='in' />
					<feComposite in='SourceGraphic' />
				</filter>
				<filter
					id='bulb'
					width='32.386'
					height='35.7'
					x='16.75'
					y='6.55'
					filterUnits='userSpaceOnUse'
				>
					<feOffset dx='.75' dy='.05' />
					<feGaussianBlur result='blur-2' stdDeviation='.5' />
					<feFlood flood-opacity='.251' />
					<feComposite in2='blur-2' operator='in' />
					<feComposite in='SourceGraphic' />
				</filter>
				<clipPath id='clip-path'>
					<circle id='mask' cx='32' cy='32' r='32' fill='url(#swipe-gradient-idea)' />
				</clipPath>
			</defs>
			<g id='idea-default' clip-path='url(#clip-path)'>
				<circle
					id='lightbulb-circle-default'
					cx='32'
					cy='32'
					r='32'
					fill='url(#swipe-gradient-idea)'
				/>
				<path
					id='lightbulb-shadow-default'
					fill='url(#linear-gradient)'
					d='M50.709 56.434l-.159 2.413 3.374 2.253-4.588 8.9L79.17 92.988v-6.369h10.955V58.727L63.765 36.42l-19.631.347-3.974 11.676z'
					opacity='0.25'
					transform='translate(-19.826 -19.717)'
				/>
				<g id='Lightbulb' transform='translate(17.5 8)'>
					<g id='bulb_shadow'>
						<g filter='url(#socket)' transform='translate(-17.5 -8)'>
							<path
								id='socket-2'
								d='M13.283 21.85H11.8v3.112a3.11 3.11 0 0 0 3.1 3.114h-.3v1.556a4.652 4.652 0 0 0 4.652 4.652 4.728 4.728 0 0 0 .794-.08 4.728 4.728 0 0 0 .794.08 4.652 4.652 0 0 0 4.652-4.652v-1.556h.2a3.107 3.107 0 0 0 3.1-3.114V21.85h-15.5z'
								class='cls-5'
								transform='translate(11.9 20.03)'
								fill='#fff'
							/>
						</g>
						<g filter='url(#bulb)' transform='translate(-17.5 -8)'>
							<path
								id='bulb-2'
								d='M24.127 4.908c-.312 0-.62.028-.928.05-.184-.008-.366-.03-.55-.03a14.015 14.015 0 0 0-10.682 23.016 12.468 12.468 0 0 1 2.933 8.024v1.64h15.5v-.02h1.48v-1.64a12.459 12.459 0 0 1 2.92-8.022 13.968 13.968 0 0 0 3.282-9.016A13.983 13.983 0 0 0 24.127 4.908z'
								class='cls-5'
								fill='#fff'
								transform='translate(8.8 3.09)'
							/>
						</g>
					</g>
					<path
						id='bulb_highlight'
						fill='#fff'
						fill-rule='evenodd'
						d='M36.6 18.918a13.953 13.953 0 1 0-24.634 9.016 12.468 12.468 0 0 1 2.934 8.024V37.6h15.5v-1.64a12.459 12.459 0 0 1 2.92-8.022 13.968 13.968 0 0 0 3.28-9.018'
						transform='translate(-8.695 -4.898)'
					/>
					<path
						id='bulb_gradient'
						fill='url(#linear-gradient-2)'
						fill-rule='evenodd'
						d='M37.341 18.908a13.953 13.953 0 1 0-24.634 9.016 12.468 12.468 0 0 1 2.928 8.024v1.64h15.5v-1.64a12.459 12.459 0 0 1 2.92-8.022 13.968 13.968 0 0 0 3.282-9.016'
						transform='translate(-7.955 -4.908)'
					/>
					<path
						id='bulb_bottom_highlight'
						d='M24.2 28.076h-9.3a3.11 3.11 0 0 1-3.1-3.114V21.85h15.5v3.112a3.107 3.107 0 0 1-3.1 3.114z'
						class='cls-5'
						fill='#fff'
						transform='translate(-5.595 12.034)'
					/>
					<path
						id='bulb_bottom_gradient'
						fill='url(#linear-gradient-3)'
						d='M24.94 28.076h-9.3a3.11 3.11 0 0 1-3.1-3.114V21.85h15.5v3.112a3.107 3.107 0 0 1-3.1 3.114z'
						transform='translate(-4.852 12.034)'
					/>
					<path
						id='bulb_socket_highlight'
						d='M22.5 26.519a4.652 4.652 0 0 1-9.3 0v-1.556h9.3z'
						class='cls-5'
						fill='#fff'
						transform='translate(-4.195 15.147)'
					/>
					<path
						id='bulb_socket'
						fill='url(#linear-gradient-4)'
						d='M23.293 26.519a4.652 4.652 0 0 1-9.3 0v-1.556h9.3z'
						transform='translate(-3.401 15.147)'
					/>
				</g>
			</g>
		</svg>
	);
};
